<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  /* height: 120px; */
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  flex:10;
  padding: 10px 15px;
  font-size: 12px;

}
.steps {
    border: 1px solid #e7e7e7
}

.steps-header {
    padding: .375rem;
    border-bottom: 1px solid #e7e7e7
}

.steps-header .progress {
    height: .25rem
}

.steps-body {
    display: table;
    table-layout: fixed;
    width: 100%
}

.step {
    display: table-cell;
    position: relative;
    padding: 1rem .75rem;
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    border-right: 1px dashed #dfdfdf;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 600;
    text-align: center;
    text-decoration: none
}

.step:last-child {
    border-right: 0
}

.step-indicator {
    display: block;
    position: absolute;
    top: .75rem;
    left: .75rem;
    width: 1.5rem;
    height: 1.5rem;
    border: 1px solid #e7e7e7;
    border-radius: 50%;
    background-color: #fff;
    font-size: .875rem;
    line-height: 1.375rem
}

.has-indicator {
    padding-right: 1.5rem;
    padding-left: 2.375rem
}

.has-indicator .step-indicator {
    top: 50%;
    margin-top: -.75rem
}

.step-icon {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 auto;
    margin-bottom: .75rem;
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    color: #888
}

.step:hover {
    color: rgba(0, 0, 0, 0.9);
    text-decoration: none
}

.step:hover .step-indicator {
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    border-color: transparent;
    background-color: #f4f4f4
}

.step:hover .step-icon {
    color: rgba(0, 0, 0, 0.9)
}

.step-active,
.step-active:hover {
    color: rgba(0, 0, 0, 0.9);
    pointer-events: none;
    cursor: default
}

.step-active .step-indicator,
.step-active:hover .step-indicator {
    border-color: transparent;
    background-color: #5c77fc;
    color: #fff
}

.step-active .step-icon,
.step-active:hover .step-icon {
    color: #5c77fc
}

.step-completed .step-indicator,
.step-completed:hover .step-indicator {
    border-color: transparent;
    background-color: rgba(51, 203, 129, 0.12);
    color: #33cb81;
    line-height: 1.25rem
}

.step-completed .step-indicator .feather,
.step-completed:hover .step-indicator .feather {
    width: .875rem;
    height: .875rem
}

.btn-show-order {
    width: 20%;
}

@media (max-width: 575.98px) {
    .btn-show-order {
        width: 100%;
    }
    .steps-header {
        display: none
    }
    .steps-body,
    .step {
        display: block
    }
    .step {
        border-right: 0;
        border-bottom: 1px dashed #e7e7e7
    }
    .step:last-child {
        border-bottom: 0
    }
    .has-indicator {
        padding: 1rem .75rem
    }
    .has-indicator .step-indicator {
        display: inline-block;
        position: static;
        margin: 0;
        margin-right: 0.75rem
    }
}

.bg-secondary {
    background-color: #f7f7f7 !important;
}

.d-none-width {
    width: 300px; 
    max-width: 250px; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.d-none-price {
    width: 190px;
}

@media only screen and (max-width: 600px) {
  .d-none-width {
    width: auto;
    max-width: 100%;
  }
  .d-none-price {
      width: auto;
  }
  .mobile-product {
      padding: 20px;
  }
  .bottom-title-left {
      text-align: right;
  }
  .bottom-title-right {
      text-align: right;
  }
  .right-side-info {
    text-align: center;
  }

  .left-side-info {
    text-align: center;
  }
}
</style>
<template>
    <div>
        <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="container">
                <div class="my-md-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-3 flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visble">
                            <li class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1"><router-link to="/home">Нүүр хуудас</router-link></li>
                            <li class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1"><a href="javascript:;">Захиалга хянах</a></li>
                        </ol>
                    </nav>
                </div>
                <div class="row mt-5">
                    <div class="col-md-2"></div>
                    <div class="col-md-8" align="center" :style="{'font-size': '18px'}">

                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <span class="font-size-16"> <span>Захиалгын дугаар: </span><span class="ikea-family-price">{{ordernumber}}</span></span>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-10 mt-10 mb-10">
                        <div class="progress-md"> 
                            <div class="order-progress"> 
                            <div>
                                <div class="order-progress-first-circe order-progress-active"> 
                                    <img v-if="step==0" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Хүлээгдэж байгаа <br><span style="font-size: 9px;"></span></div>
                                </div> 
                                <div class="order-progress-middle-line " :class="{'order-progress-active':step>=1}"></div> 
                                <div class="order-progress-second-circle " :class="{'order-progress-active':step>=1}">
                                    <img v-if="step==1" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div ><span style="font-size: 9px;">{{StatusDate.paid}}</span> <br>Таны төлбөр амжилттай төлөгдлөө</div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=2}"></div> 
                                <div class="order-progress-third-circle" :class="{'order-progress-active':step>=2}">
                                    <img v-if="step==2" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div>Таны захиалга амжилттай баталгаажлаа <br><span style="font-size: 9px;">{{StatusDate.ordered}}</span></div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=3}"></div>  
                                <div class="order-progress-second-circle" :class="{'order-progress-active':step>=3}">
                                    <img v-if="step==3" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div ><span style="font-size: 9px;">{{StatusDate.loaded}}</span> <br>Таны захиалга Бээжин дэх дэлгүүрээс ачигдлаа</div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=4}"></div> 
                                <div class="order-progress-third-circle" :class="{'order-progress-active':step>=4}">
                                    <img v-if="step==4" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Таны захиалга Эрээн хотын агуулахад ирлээ <br><span style="font-size: 9px;">{{StatusDate.came_in_ereen}}</span></div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=5}"></div> 
                                <div class="order-progress-second-circle" :class="{'order-progress-active':step>=5}">
                                    <img v-if="step==5" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div ><span style="font-size: 9px;">{{StatusDate.came_in_ub}}</span> <br>Таны захиалга УБ хотод ирсэн ялгалт хийгдэж байна</div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=6}"></div> 
                                <div class="order-progress-third-circle" :class="{'order-progress-active':step>=6}">
                                    <img v-if="step==6" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Хэрэглэгчийн болон түгээлтийн хаяг руу хүргэлт хийгдэж байна <br><span style="font-size: 9px;">{{StatusDate.in_stock}}</span></div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=7}"></div> 
                                <div class="order-progress-second-circle" :class="{'order-progress-active':step>=7}">
                                    <img v-if="step==7" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div ><span style="font-size: 9px;">{{StatusDate.delivered}}</span> <br>Амжилттай гарт олголоо</div>
                                </div>
                            </div>
                            <div class="order-date"><span>Барааг хүлээн авах өдөр: </span><br><b class="font-size-14 ikea-family-price" v-if="orders.length>0">{{getGiveDate(ordernumber)}}</b></div>
                            </div>
                        </div>
                        <div class="progress-sm"> 
                            <div style="font-size:11px;margin-left: 60px;"> 
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=0}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==0" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Хүлээгдэж байгаа
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=1}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=1}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==1" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Таны төлбөр амжилттай төлөгдлөө
                                    <br><span style="font-size: 9px;">{{StatusDate.paid}}</span>
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=2}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=2}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==2" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Таны захиалга амжилттай баталгаажлаа
                                    <br><span style="font-size: 9px;">{{StatusDate.ordered}}</span>
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=3}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=3}">
                                <div style="height: 10px;"> 
                                    <img v-if="step==3" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Таны захиалга Бээжин дэхдэлгүүрээс ачигдлаа
                                    <br><span style="font-size: 9px;">{{StatusDate.loaded}}</span>
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=4}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=4}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==4" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Таны захиалга Эрээн хотын агуулахад ирлээ
                                    <br><span style="font-size: 9px;">{{StatusDate.came_in_ereen}}</span>
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=5}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=5}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==5" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Таны захиалга Улаанбаатар хотод ирсэн ялгалт хийгдэж байна
                                    <br><span style="font-size: 9px;">{{StatusDate.came_in_ub}}</span>
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=6}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=6}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==6" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Хэрэглэгч болон түгээлтийн хаяг руу хүргэлт хийгдэж байна
                                    <br><span style="font-size: 9px;">{{StatusDate.in_stock}}</span>
                                </div>
                            </div>
                            <div class="order-progress-mobile-line" :class="{'order-progress-active':step>=7}"> </div>
                            <div class="order-progress-mobile" :class="{'order-progress-active':step>=7}"> 
                                <div style="height: 10px;"> 
                                    <img v-if="step==7" src="@/assets/svg/checkmark.svg" class="check-svg-mob">
                                </div>
                                <div > 
                                    Амжилттай гарт олголоо
                                </div>
                            </div>
                            <div class="order-date"><span>Барааг хүлээн авах өдөр: </span><br><b class="font-size-14 ikea-family-price" v-if="orders.length>0">{{getGiveDate(ordernumber)}}</b></div>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-12"> 
                        <div class="card m-2" v-for="(item,index) in orders" :key="index" @click="changeOrder(item.ordernumber)">
                            <div class="check" style="display: flex;justify-items: center;align-items: center;justify-content: center;width: 30%;"> 
                                   <input type="checkbox"  v-model="item.checked" @change="changeOrder(item.ordernumber)">
                            </div>
                            <div style="width: 70%;"> 
                                <span>Захиалгын дугаар: <span class="ikea-family-price">{{item.ordernumber}}</span></span><br> 
                                <span>Захиалсан огноо: <b class="ikea-family-price">{{(item.created_at).replace('T',' ').replace(/\..+/, '')}}</b> </span><br>
                                <span> Захиалгын дүн: <b class="ikea-family-price">₮{{Number(item.total_amount).toLocaleString()}}</b></span><br>                            
                                <span> Төлөв: 
                                    <span class="ikea-family-price" v-if="item.status=='pending'">Төлбөр хүлээгдэж байгаа</span>
                                    <span class="ikea-family-price" v-if="item.status=='paid'">Төлбөр төлөгдсөн</span>
                                    <span class="ikea-family-price" v-if="item.status=='ordered'">Баталгаажсан</span>
                                    <span class="ikea-family-price" v-if="item.status=='loaded'">Бээжин дахь IKEA дэлгүүрээс ачигдсан</span>
                                    <span class="ikea-family-price" v-if="item.status=='came_in_ereen'">Эрээнд ирсэн</span>
                                    <span class="ikea-family-price" v-if="item.status=='came_in_ub'">Улаанбаатарт ирсэн ялгалт хийгдэж байна</span>
                                    <span class="ikea-family-price" v-if="item.status=='in_stock'">Хэрэглэгчийн хаяг болон түгээлтийн  байршил руу хүргэлт хийгдэж байна</span>
                                </span><br>
                                <span>Барааг хүлээн авах өдөр: <b class="ikea-family-price">{{getGiveDate(item.ordernumber)}}</b></span>                           
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                    </div>
                </div>
            </div>
        </main>
        <Brands />
    </div>
</template>
<script>
import Brands from "@/components/brands";
import { url } from "vuelidate/lib/validators";
export default {
    components: {
        Brands
    },
    data() {
        return {
            ordernumber:'',
            fullscreenLoading: false,
            data: false,
            step: 0,
            progress: 0,
            searchInput: '',
            orders:[],
            giveDate:'',
            StatusDate:{
                  paid:'',
                  ordered:'',
                  loaded:'',
                  came_in_ereen:'',
                  came_in_ub:'',
                  in_stock:'',
                  delivered:''
            }
        }
    },
    mounted() {
        this.$emit('getJquery');
        this.submit();
    },
    methods: {
        changeOrder(number){
           this.ordernumber=number;
           this.getInfo();
        },
        getGiveDate(number){
            var rts=this;
            var str='';
            Date.prototype.addDays = function(days){
                var date = new Date(this.valueOf());
                date.setDate(date.getDate() + days);
                return date;
            }
            rts.orders.forEach(el=>{
                if(el.ordernumber===number){
                    let startDate=new Date(el.created_at).addDays(12);
                    let endDate=new Date(el.created_at).addDays(16);
                    str+=(startDate.getMonth()+1)+'.'+startDate.getDate();
                    str+=' - '+(endDate.getMonth()+1)+'.'+endDate.getDate();
                }
            })
            // rts.giveDate=str;
            return str
        },

        getInfo(){
            this.orders.forEach(item=>{
                if(item.ordernumber==this.ordernumber){
                    item.checked=true;
                              this.StatusDate.paid=item.paid != null ? item.paid : '';
                              this.StatusDate.ordered=item.ordered !=null ? item.ordered : '';
                              this.StatusDate.loaded=item.loaded != null ? item.loaded : '';
                              this.StatusDate.came_in_ereen=item.came_in_ereen != null ? item.came_in_ereen : '';
                              this.StatusDate.came_in_ub=item.came_in_ub != null ? item.came_in_ub :'';
                              this.StatusDate.in_stock=item.in_stock != null ? item.in_stock : '';
                              this.StatusDate.delivered=item.delivered !=null ? item.delivered : '';
                              if(item.status=='pending'){
                                this.step=0
                              }else if(item.status=='paid'){
                                this.step=1;
                              }else if(item.status=='ordered'){
                                this.step=2
                              }else if(item.status=='loaded'){
                                this.step=3
                              }else if(item.status=='came_in_ereen'){
                                this.step=4
                              }else if(item.status=='came_in_ub'){
                                this.step=5
                              }else if(item.status=='in_stock'){
                                this.step=6
                              }else{
                                this.step=7
                              }
                }else{
                    item.checked=false;
                }
            })
        },
        showProducts() {
            this.dialogTableVisible = true;
        },
        submit() {
            const token = localStorage.getItem('token');
                if(!token) {
                    this.$notify({
                        title: 'Амжилтгүй',
                        message: `Нэвтэрсэн байх шаардлагатай`,
                        type: 'error'
                    });
                    this.$router.push('/login');
                } else {
                    var rts = this;
                    rts.$axios({
                        method: 'POST',
                        url: rts.$appUrl + '/api/product/show-orders',
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }).then(data => {
                        if(data.data.result == 'failed') {
                            rts.$notify({
                                title: 'Амжилтгүй',
                                message: `Танд захиалга алга`,
                                type: 'error'
                            });
                        } else{
                              rts.ordernumber=data.data.order[data.data.order.length-1].ordernumber;
                              rts.orders=data.data.order;
                              rts.getInfo();
                        }
                    }).catch(err => {
                        console.log(err);
                        rts.$router.push('/error-page');
                    });
                }
        }
    }
}
</script>